import type { SVGProps } from 'react';

const SvgEmojiLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z'
      stroke='currentColor'
      strokeLinejoin='round'
    />
    <path
      d='M10 10C10 10.5523 9.55228 11 9 11C8.44772 11 8 10.5523 8 10C8 9.44772 8.44772 9 9 9C9.55228 9 10 9.44772 10 10Z'
      fill='currentColor'
    />
    <path
      d='M16 10C16 10.5523 15.5523 11 15 11C14.4477 11 14 10.5523 14 10C14 9.44772 14.4477 9 15 9C15.5523 9 16 9.44772 16 10Z'
      fill='currentColor'
    />
    <path d='M9.0001 10H9' stroke='currentColor' strokeLinecap='round' />
    <path d='M15.0001 10H15' stroke='currentColor' strokeLinecap='round' />
    <path
      d='M16 14.5C15.0878 15.7145 13.6356 16.5 12 16.5C10.3644 16.5 8.91223 15.7145 8 14.5'
      stroke='currentColor'
      strokeLinecap='round'
    />
  </svg>
);
export default SvgEmojiLt;
